var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2301_8276)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.325C10.325 6.225 10.1 6.225 9.9 6.325L8.5 7.15L7.55 7.675L6.175 8.5C6 8.6 5.775 8.6 5.575 8.5L4.5 7.85C4.325 7.75 4.2 7.55 4.2 7.325V6.075C4.2 5.875 4.3 5.675 4.5 5.55L5.575 4.925C5.75 4.825 5.975 4.825 6.175 4.925L7.25 5.575C7.425 5.675 7.55 5.875 7.55 6.1V6.925L8.5 6.375V5.525C8.5 5.325 8.4 5.125 8.2 5L6.2 3.825C6.025 3.725 5.8 3.725 5.6 3.825L3.55 5.025C3.35 5.125 3.25 5.325 3.25 5.525V7.875C3.25 8.075 3.35 8.275 3.55 8.4L5.575 9.575C5.75 9.675 5.975 9.675 6.175 9.575L7.55 8.775L8.5 8.225L9.875 7.425C10.05 7.325 10.275 7.325 10.475 7.425L11.55 8.05C11.725 8.15 11.85 8.35 11.85 8.575V9.825C11.85 10.025 11.75 10.225 11.55 10.35L10.5 10.975C10.325 11.075 10.1 11.075 9.9 10.975L8.825 10.35C8.65 10.25 8.525 10.05 8.525 9.825V9.025L7.575 9.575V10.4C7.575 10.6 7.675 10.8 7.875 10.925L9.9 12.1C10.075 12.2 10.3 12.2 10.5 12.1L12.525 10.925C12.7 10.825 12.825 10.625 12.825 10.4V8.025C12.825 7.825 12.725 7.625 12.525 7.5L10.5 6.325Z",
    fill: "#8247E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_8276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon-icon.43788fbb42fd842a6e09d329953b1973.svg";
export { ForwardRef as ReactComponent };